import Layout from 'layouts/MountainInformationNetwork/list/SubmissionList'

export default function SubmissionList() {
    return <Layout />
}
